import { jsx as o } from "react/jsx-runtime";
import { createContext as n, useContext as s } from "react";
const d = {
  loginPage: {
    title: "Log In",
    forgotPassword: "Forgot password?",
    login: "Log in",
    description: `Enter your details
to sign in to your account`
  },
  confirmEmailPage: {
    title: "Confirm Email",
    confirmedMessage: "Your email has been confirmed. You can now log in.",
    confirmEmailMessage: "Confirm your email adress to log in. We've sent a confirmation link to:",
    isLoading: "Sending...",
    resendLink: "Resend Link",
    backToLogin: "Back to Login",
    spamEmail: "Don't forget to check your spam folder",
    confirming: "Confirming your email",
    confirmingError: "Failed to confirm your email. Please try again."
  },
  forgotPasswordPage: {
    title: "Forgot Password",
    recoverPassword: "Recover Password",
    emailSentSuccess: "A link to reset your password has been sent to your email.",
    description: `Enter your email
to recover your password`
  },
  resetPasswordPage: {
    resetPassword: "Reset Password",
    passwordPlaceholder: "Enter new password",
    confirmPasswordPlaceholder: "Confirm new password",
    login: "Log in",
    success: {
      passwordReset: "Your password has been reset!",
      backToLogin: "Back to Login"
    }
  },
  signupPage: {
    namePlaceholder: "Enter your name",
    confirmPasswordPlaceholder: "Confirm your password",
    signup: "Sign Up",
    description: `Enter your details
to create a new account`
  },
  feedback: {
    input: "Type your feedback here...",
    success: "Feedback sent",
    failed: "Failed to send feedback"
  },
  searchPromptPage: {
    subtitle: "Ask in natural language what you are searching for"
  },
  userDropdown: {
    changePassword: "Change Password",
    logout: "Log Out",
    pending: "Sending reset password email...",
    success: "A link to reset your password has been sent to your email.",
    error: "Failed to send reset password email. Please try again."
  },
  searchBar: {
    placeholder: "Search Qura AI...",
    searchingStatus: "Searching in document",
    documentMatch: "Document Match",
    suggestions: "Suggestions",
    searchHistory: "Search History",
    seeAll: "See all",
    inDocumentSearch: "Search in document"
  },
  searchHistory: {
    searchHistory: "Search History",
    documentsVisited: {
      one: "{{count}} visited document",
      other: "{{count}} visited documents"
    }
  },
  searchResult: {
    openTag: "Open",
    noSearchResults: "No search results found",
    tryUpdateFilters: "Try updating your filters or query.",
    newSearch: "New Search",
    searchMatch: "Search match",
    pageNumberShort: "p.",
    openPdf: "Open",
    clickToExpand: "Click to expand",
    clickToMinimize: "Click to minimize",
    previewLoading: "Loading preview...",
    previewError: "Failed to load preview",
    noPreview: "No preview available",
    feedbackSubmitted: "Thank you for your feedback!",
    keywords: "Keywords"
  },
  searchDocumentPage: {
    title: "Search results in document",
    downloadDocumentWithHighlights: "Download PDF with highlights",
    downloadDocumentWithoutHighlights: "Download PDF without highlights",
    downloadHighlightedPages: "Download highlighted pages",
    printDocumentWithHighlights: "Print PDF with highlights",
    printDocumentWithoutHighlights: "Print PDF without highlights",
    printHighlightedPages: "Print highlighted pages",
    downloadError: "Failed to download PDF",
    backToSearch: "Back to search",
    foundChunksCount: {
      one: "Found {{count}} relevant page",
      other: "Found {{count}} relevant pages"
    },
    loadingChunks: "Loading pages...",
    noChunksFound: "No relevant pages found",
    referenceNotFound: "Document currently not available",
    citedDocuments: "Cited Documents",
    citedByDocuments: "Cited By Documents",
    relatedDocuments: "Related Documents",
    deepSearch: "Refine Search"
  },
  documentMetadata: {
    legal_id: "Legal ID",
    publication_date: "Publication Date",
    source: "Source",
    no_source_link: "Source not available"
  },
  filters: {
    filter: "Filter",
    filterByYear: "Filter by year",
    applyFilters: "Apply selected filters",
    from: "From",
    to: "to",
    reset: "Reset",
    legalSources: "Legal Sources",
    date: "Date"
  },
  errors: {
    invalidCredentials: "Invalid Credentials",
    network: "You are offline.",
    invalidSignupToken: "Your signup link is invalid.",
    emailNotConfirmed: "Email not confirmed.",
    emailAlreadyUsed: "Email has already been used with another account.",
    noResults: "No results found.",
    loadResourcesFailed: `Our servers are currently down.
Please try again later.`,
    resultChunkFailed: "Failed to load preview in ResultChunk with react pdf document. Error: ",
    unknown: "An unknown has error occurred.",
    invalidSearchId: "Was not able to find the search on this link.",
    invalidEmail: "Your email is invalid.",
    invalidPassword: "Your password is invalid.",
    invalidUsername: "Your name is invalid.",
    document404Title: "Could not find the document",
    document404Description: "Please write in the feedback form if this should be a link to a document.",
    search404Title: "Could not find the search",
    search404Description: "Please write in the feedback form if this should not have happened.",
    dataRole404Title: "User is not valid",
    dataRole404Description: "Please contact us to resolve this.",
    errorPageTitle: "Unknown Error",
    errorPageDescription: "This should not have happened. Please write in the feedback form to help us understand what went wrong.",
    searchFailed: "Failed to start search. Please try again.",
    nameRequired: "Name is required.",
    nameTooShort: "Name must be at least three characters long.",
    emailRequired: "Email is required.",
    emailInvalid: "Invalid email format.",
    passwordRequired: "Password is required.",
    passwordTooShort: "Password must be at least 8 characters long.",
    passwordMismatch: "Passwords do not match."
  },
  common: {
    tryAgain: "Try again",
    passwordPlaceholder: "Enter your password",
    emailPlaceholder: "Enter your email",
    login: "Login",
    loading: "Loading...",
    password: "Password",
    email: "Email",
    confirmPassword: "Confirm password",
    name: "Name",
    month: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    weekday: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    lastWeekday: [
      "Last Sunday",
      "Last Monday",
      "Last Tuesday",
      "Last Wednesday",
      "Last Thursday",
      "Last Friday",
      "Last Saturday"
    ],
    backToHome: "Back to home",
    loadMore: "Load more"
  },
  searchStatus: {
    searchScore: "Search Score",
    documentsFound: "Found Documents",
    documentsSearched: "Searched Documents",
    analyzingQuery: "Analyzing Query",
    searchingDatabases: "Searching Database",
    rankingDocuments: "Ranking Documents",
    done: "Done",
    completed: "Completed",
    ongoing: "In Progress...",
    pending: "Pending",
    error: "Failed"
  },
  layout: {
    allResults: "All Results"
  },
  databaseInformation: {
    databaseInformation: "Database Information"
  },
  examplePrompts: {
    swe: [
      "Hur ska köp av osäkra fordringar behandlas i mervärdesskattehänseende?",
      "Vad har brottslighetens art tillmätts för betydelse vid påföljdsval i rättspraxis?",
      "När kan en statlig myndighet ha klagorätt genom att företräda ett privaträttsligt intresse?"
    ],
    eu: [
      'How is "communication to the public" interpreted in article 3(19) of Directive 2001/29?',
      "How does judicial independence relate to the right to a fair trial?",
      'How to decide where a child is a "habitually resident"?'
    ],
    default: [
      'How is "communication to the public" interpreted in article 3(19) of Directive 2001/29?',
      "How does judicial independence relate to the right to a fair trial?",
      'How to decide where a child is a "habitually resident"?'
    ]
  },
  authFooter: "Qura uses AI to find the relevant laws, cases and regulations for any legal context. We strive to transform legal research.",
  authFooterAlt1: "© 2024 Lawlabs AB ",
  authFooterAlt2: "Stockholm 111 20",
  onboardingPage: {
    title: "Get Started with Our Quick Guide",
    welcomeMessage: "Welcome to Qura!",
    learnHowToUseQura: "Learn how to use Qura.",
    description: "We provide tips on how to make the best use of our powerful AI search engine and its features.",
    viewQuickGuide: "View Quick Guide",
    showMeLater: "Show me later",
    haveMoreQuestions: "Do you have more questions?",
    contactTeam: "Contact the team",
    quickGuideUrl: "https://www.qura.law/quick-guide-en"
  },
  helpButton: {
    modalLabel: "Do you need help?",
    modalTitle: "Quick Guide",
    modalDescription: "Learn how to use Qura's powerful AI search engine.",
    viewQuickGuide: "View Quick Guide",
    haveMoreQuestions: "Do you have more questions?",
    contactTeam: "Contact the team",
    notificationTitle: "Quick Guide",
    notificationDescription: "You can always find it in the question mark."
  },
  relatedDocuments: {
    title: "Related Documents",
    citedDocuments: "Cited Documents",
    citedByDocuments: "Cited By Documents"
  },
  NPSForm: {
    modalLabel: "Help us get better",
    modalQuestion: "How likely are you to recommend Qura to a friend or colleague?",
    dismissButton: "Remind me later",
    lowerBound: "1 = Not likely",
    upperBound: "10 = Very likely"
  }
}, l = {
  loginPage: {
    title: "Logga in",
    forgotPassword: "Glömt lösenord?",
    login: "Logga in",
    description: `Ange dina uppgifter
för att logga in`
  },
  confirmEmailPage: {
    title: "Bekräfta e-post",
    confirmedMessage: "Din e-post har bekräftats. Du kan nu logga in.",
    confirmEmailMessage: "Bekräfta din e-postadress för att logga in. Vi har skickat en bekräftelselänk till:",
    isLoading: "Skickar...",
    resendLink: "Skicka länken igen",
    backToLogin: "Tillbaka till inloggning",
    spamEmail: "Glöm inte att kolla din skräppost",
    confirming: "Bekräftar din e-post",
    confirmingError: "Misslyckades med att bekräfta din e-post. Försök igen."
  },
  forgotPasswordPage: {
    title: "Glömt lösenord",
    recoverPassword: "Återställ lösenord",
    emailSentSuccess: "En länk för att återställa ditt lösenord har skickats till din e-post.",
    description: `Ange din e-post
för att återställa ditt lösenord`
  },
  resetPasswordPage: {
    resetPassword: "Återställ lösenord",
    passwordPlaceholder: "Ange nytt lösenord",
    confirmPasswordPlaceholder: "Bekräfta nytt lösenord",
    success: {
      passwordReset: "Ditt lösenord har återställts!",
      backToLogin: "Tillbaka till inloggning"
    },
    login: "Logga in"
  },
  signupPage: {
    namePlaceholder: "Ange ditt namn",
    confirmPasswordPlaceholder: "Bekräfta ditt lösenord",
    signup: "Registrera dig",
    description: `Enter your details
to create a new account`
  },
  feedback: {
    input: "Skriv din feedback här...",
    success: "Feedback skickad",
    failed: "Misslyckades med att skicka feedback"
  },
  searchPromptPage: {
    subtitle: "Skriv i fritext vad du söker efter"
  },
  userDropdown: {
    changePassword: "Byt lösenord",
    logout: "Logga ut",
    pending: "Skickar e-post för återställning av lösenord...",
    success: "En länk för att återställa ditt lösenord har skickats till din e-post.",
    error: "Misslyckades med att skicka e-post för återställning av lösenord. Försök igen."
  },
  searchBar: {
    placeholder: "Sök Qura AI...",
    searchingStatus: "Söker i dokument",
    documentMatch: "Dokumentmatch",
    suggestions: "Förslag",
    searchHistory: "Sökhistorik",
    seeAll: "Visa allt",
    inDocumentSearch: "Sök i dokument"
  },
  searchHistory: {
    searchHistory: "Sökhistorik",
    documentsVisited: {
      one: "{{count}} besökt dokument",
      other: "{{count}} besökta dokument"
    }
  },
  searchResult: {
    openTag: "Öppna",
    noSearchResults: "Inga sökresultat hittades",
    tryUpdateFilters: "Försök att uppdatera dina filter eller sökfråga.",
    newSearch: "Ny sökning",
    searchMatch: "Matchar",
    pageNumberShort: "s.",
    openPdf: "Öppna",
    clickToExpand: "Klicka för att expandera",
    clickToMinimize: "Klicka för att minimera",
    previewLoading: "Laddar förhandsvisning...",
    previewError: "Misslyckades med att ladda förhandsvisning",
    noPreview: "Ingen förhandsvisning tillgänglig",
    feedbackSubmitted: "Tack för din feedback!",
    keywords: "Nyckelord"
  },
  searchDocumentPage: {
    title: "Sökresultat i dokument",
    downloadDocumentWithHighlights: "Ladda ner PDF med markeringar",
    downloadDocumentWithoutHighlights: "Ladda ner PDF utan markeringar",
    downloadHighlightedPages: "Ladda ner endast markeringar",
    printDocumentWithHighlights: "Skriv ut PDF med markeringar",
    printDocumentWithoutHighlights: "Skriv ut PDF utan markeringar",
    printHighlightedPages: "Skriv ut endast markeringar",
    downloadError: "Misslyckades med att ladda ner PDF",
    backToSearch: "Tillbaka till sökning",
    foundChunksCount: {
      one: "Hittade {{count}} relevant sida",
      other: "Hittade {{count}} relevanta sidor"
    },
    loadingChunks: "Laddar sidor...",
    noChunksFound: "Inga relevanta sidor hittades",
    referenceNotFound: "Dokumentet är för närvarande inte tillgängligt",
    citedDocuments: "Refererade dokument",
    citedByDocuments: "Refereras av dokument",
    relatedDocuments: "Relaterade dokument",
    deepSearch: "Förfina sökning"
  },
  documentMetadata: {
    legal_id: "Juridiskt ID",
    publication_date: "Publiceringsdatum",
    source: "Källa",
    no_source_link: "Källa ej tillgänglig"
  },
  filters: {
    filter: "Filter",
    filterByYear: "Filtrera efter år",
    applyFilters: "Tillämpa valda filter",
    from: "Från",
    to: "till",
    reset: "Återställ",
    legalSources: "Rättskällor",
    date: "Datum"
  },
  errors: {
    invalidCredentials: "Ogiltiga uppgifter",
    network: "Du är offline.",
    invalidSignupToken: "Din registreringslänk är ogiltig.",
    emailNotConfirmed: "E-post ej bekräftad.",
    emailAlreadyUsed: "E-post har redan använts med ett annat konto.",
    noResults: "Inga resultat hittades.",
    loadResourcesFailed: `Våra servrar är för närvarande nere.
Försök igen senare.`,
    resultChunkFailed: "Misslyckades med att läsa in förhandsgranskning i ResultChunk med react pdf dokument. Fel: ",
    unknown: "Ett okänt fel har inträffat.",
    invalidSearchId: "Kunde inte hitta sökningen på denna länk.",
    invalidEmail: "Din e-post är ogiltig.",
    invalidPassword: "Ditt lösenord är ogiltigt.",
    invalidUsername: "Ditt namn är ogiltigt.",
    document404Title: "Kunde inte hitta dokumentet",
    document404Description: "Skriv gärna i feedback rutan om detta borde vara en länk till ett dokument.",
    search404Title: "Kunde inte hitta sökningen",
    search404Description: "Skriv gärna i feedback rutan om detta inte borde ha hänt.",
    dataRole404Title: "Användaren är ogiltig",
    dataRole404Description: "Kontakta oss för att lösa detta.",
    errorPageTitle: "Okänt Fel",
    errorPageDescription: "Detta borde inte ha hänt. Skriv gärna i feedback rutan för att hjälpa oss förstå vad som gick fel.",
    searchFailed: "Misslyckades med att starta sökningen. Försök igen.",
    nameRequired: "Namn är obligatoriskt.",
    nameTooShort: "Namn måste vara minst tre tecken långt.",
    emailRequired: "E-post är obligatorisk.",
    emailInvalid: "Ogiltig e-postadress.",
    passwordRequired: "Lösenord är obligatoriskt.",
    passwordTooShort: "Lösenord måste vara minst 8 tecken långt.",
    passwordMismatch: "Lösenorden matchar inte."
  },
  common: {
    tryAgain: "Försök igen",
    passwordPlaceholder: "Ange ditt lösenord",
    emailPlaceholder: "Ange din e-post",
    login: "Logga in",
    loading: "Laddar...",
    password: "Lösenord",
    email: "E-post",
    confirmPassword: "Bekräfta lösenord",
    name: "Namn",
    month: [
      "januari",
      "februari",
      "mars",
      "april",
      "maj",
      "juni",
      "juli",
      "augusti",
      "september",
      "oktober",
      "november",
      "december"
    ],
    weekday: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
    today: "Idag",
    yesterday: "Igår",
    tomorrow: "Imorgon",
    lastWeekday: [
      "I söndags",
      "I måndags",
      "I tisdags",
      "I onsdags",
      "I torsdags",
      "I fredags",
      "I lördags"
    ],
    backToHome: "Tillbaka till startsidan",
    loadMore: "Ladda fler"
  },
  layout: {
    allResults: "Alla resultat"
  },
  searchStatus: {
    searchScore: "Träffsäkerhet",
    documentsFound: "Hittade dokument",
    documentsSearched: "Sökta dokument",
    analyzingQuery: "Analyserar frågan",
    searchingDatabases: "Söker i databasen",
    rankingDocuments: "Rankar dokumenten",
    done: "Klar",
    completed: "Färdig",
    ongoing: "Pågående...",
    pending: "Väntar",
    error: "Misslyckades"
  },
  databaseInformation: {
    databaseInformation: "Databasinformation"
  },
  authFooter: "Qura använder AI för att hitta relevanta lagar, fall och förordningar för varje juridiskt sammanhang. Vi strävar efter att transformera juridisk forskning.",
  authFooterAlt1: "© 2024 Lawlabs AB ",
  authFooterAlt2: "Stockholm 111 20",
  examplePrompts: {
    swe: [
      "Hur ska köp av osäkra fordringar behandlas i mervärdesskattehänseende?",
      "Vad har brottslighetens art tillmätts för betydelse vid påföljdsval i rättspraxis?",
      "När kan en statlig myndighet ha klagorätt genom att företräda ett privaträttsligt intresse?"
    ],
    eu: [
      'How is "communication to the public" interpreted in article 3(19) of Directive 2001/29?',
      "How does judicial independence relate to the right to a fair trial?",
      'How to decide where a child is a "habitually resident"?'
    ],
    default: [
      "Hur ska köp av osäkra fordringar behandlas i mervärdesskattehänseende?",
      "Vad har brottslighetens art tillmätts för betydelse vid påföljdsval i rättspraxis?",
      "När kan en statlig myndighet ha klagorätt genom att företräda ett privaträttsligt intresse?"
    ]
  },
  onboardingPage: {
    title: "Kom igång med vår Quick Guide",
    welcomeMessage: "Välkommen till Qura!",
    learnHowToUseQura: "Lär dig hur du använder Qura.",
    description: "Vi ger dig tips på hur du utnyttjar vår kraftfulla AI-sökmotor och dess funktioner på bästa sätt.",
    viewQuickGuide: "Se Quick Guide",
    showMeLater: "Visa mig senare",
    haveMoreQuestions: "Har du fler frågor?",
    contactTeam: "Kontakta teamet",
    quickGuideUrl: "https://www.qura.law/quick-guide"
  },
  helpButton: {
    modalLabel: "Behöver du hjälp?",
    modalTitle: "Quick Guide",
    modalDescription: "Lär dig hur du utnyttjar Quras kraftfulla AI-sökmotor.",
    viewQuickGuide: "Se Quick Guide",
    haveMoreQuestions: "Har du fler frågor?",
    contactTeam: "Kontakta teamet",
    notificationTitle: "Quick Guide",
    notificationDescription: "Du hittar den alltid i frågetecknet."
  },
  relatedDocuments: {
    title: "Relaterade dokument",
    citedDocuments: "Citerade dokument",
    citedByDocuments: "Citerat av dokument"
  },
  NPSForm: {
    modalLabel: "Hjälp oss att bli bättre",
    modalQuestion: "Hur troligt är det att du skulle rekommendera Qura till en vän eller kollega?",
    dismissButton: "Påminn mig senare",
    lowerBound: "1 = Inte troligt",
    upperBound: "10 = Mycket troligt"
  }
}, u = {
  en: d,
  sv: l
}, i = n({ locale: "sv" }), h = () => {
  const e = s(i);
  if (!e)
    throw new Error("useTranslations must be used within a TranslationsProvider");
  return u[e.locale];
}, k = ({ children: e, locale: a }) => /* @__PURE__ */ o(i.Provider, { value: { locale: a }, children: e }), c = (e, a) => e.replace(/{{[ \w]+}}/g, (t) => {
  const r = t.slice(2, -2).trim();
  return r in a ? String(a[r]) : t;
}), p = (e, a) => {
  let t;
  if (a === 0 ? t = e.zero : a === 1 ? t = e.one : a > 1 && (t = e.many), t || (t = e.other), !t) throw new Error("No template found for count");
  return c(t, { count: a });
};
export {
  k as TranslationsProvider,
  p as evaluateCountInTemplate,
  c as insertVariablesInTemplate,
  h as useTranslations
};
//# sourceMappingURL=index.js.map
